$(function(){
	$('.menu-guide a[href^=#], .menu-store a[href^=#], .menu-list a[href^=#], .go-top a[href^=#]').click(function() {
		var speed = 800;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;

		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
	$('.noshi-nav ul li a[href^=#]').click(function() {
		var speed = 800;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 70;

		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

  $(window).scroll(function () {
      var scroll = $(window).scrollTop();
			if (scroll > 150){
				$("body").addClass("on");
            } else {
				$("body").removeClass("on");
			}
  });
  
});